import axios from 'axios/index'

const namespaced = true

const state = {
  reportMenuItems: [],
  reportItemLink: null,
  controls: null,
  reportFields: [],
  reportItems: [],
  busyState: false,
  cancelToken: null,
  source: null
}
const getters = {
  // reportFields: state => {
  //   let fields = null
  //   state.reportMenuItems.forEach((elm) => {
  //     if (elm.name === state.reportItemLink) {
  //       fields = elm.fields
  //     }
  //   })
  //   return fields;
  // },
  // reportControls: state => {
  //   let controls = null
  //   state.reportMenuItems.forEach((elm) => {
  //     if (elm.name === state.reportItemLink) {
  //       elm.controls.forEach((element) => {
  //         element.values = {}
  //         element.params.forEach(param => {
  //           element.values[param] = null;
  //         })
  //       })
  //       controls = elm.controls;
  //     }
  //   })
  //   return controls;
  // }
}
const actions = {
  getReportParams ({ state, rootState, commit }) {
    return axios({
      method: 'GET',
      url: '/api/private/v3.0/piportals/' + rootState.authorization.userInfo.piportals[0].alias + '/reports/' + state.reportItemLink + '/properties/'
    })
      .then(response => {
        console.log(response)
        commit('setReportData', response.data)
      })
      .catch(error => {
        console.log(error)
      })
  },
  getReportData ({ rootState, commit }, data) {
    commit('setSourceToken')
    commit('setBusyState', true)
    const params = new URLSearchParams(data).toString()
    const url = '/api/private/v3.0/piportals/' + rootState.authorization.userInfo.piportals[0].alias + '/reports/' + state.reportItemLink + '?'
    return axios({
      method: 'GET',
      url: url + params,
      cancelToken: state.source.token
    })
      .then(response => {
        console.log(response)
        commit('setReportItems', response.data)
        commit('setBusyState', false)
      })
      .catch(error => {
        if (axios.isCancel(error)) {
          commit('setBusyState', false)
          commit('unsetSourceToken')
          console.log('Request canceled: ', error.message)
        } else {
          console.log(error)
        }
      })
  },
  getReportExcelData ({ rootState, commit }, data) {
    commit('setBusyState', true)
    const params = new URLSearchParams(data).toString()
    const url = '/api/private/v3.0/piportals/' + rootState.authorization.userInfo.piportals[0].alias + '/reports/' + state.reportItemLink + '/xlsx?'
    return axios({
      method: 'GET',
      url: url + params,
      responseType: 'blob'
    })
      .then(response => {
        console.log(response)
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'report.xls')
        document.body.appendChild(link)
        link.click()
        commit('setBusyState', false)
      })
      .catch(error => {
        console.log(error)
      })
  }
}
const mutations = {
  changeReportItem (state, data) {
    state.reportItemLink = data
  },
  setReportData (state, data) {
    for (const key in data.fields) {
      const fieldItem =
        {
          key: key,
          label: data.fields[key]
        }
      state.reportFields.push(fieldItem)
    }
    data.controls.forEach((elm) => {
      elm.values = {}
      elm.params.forEach(param => {
        elm.values[param] = null
      })
    })
    state.controls = data.controls
  },
  setReportItems (state, data) {
    state.reportItems = data.data
  },
  setReportItemsToZero (state) {
    state.reportItems = []
    state.reportFields = []
  },
  setReportFieldsToZero (state) {
    state.reportFields = null
  },
  setBusyState (state, data) {
    state.busyState = data
  },
  setSourceToken (state) {
    state.cancelToken = axios.CancelToken
    state.source = state.cancelToken.source()
  },
  cancelSourceToken (state, value) {
    if (state.source !== null) {
      state.source.cancel(value.message)
    }
  },
  unsetSourceToken (state) {
    state.cancelToken = null
    state.source = null
  }
}

export default {
  namespaced,
  state,
  actions,
  mutations,
  getters
}
